module.exports = __webpack_public_path__ + "static/media/img-unlimited-clients.ad4fa469.png";